import { enableWebSdk } from "../../functions/index";

(async () => {
	/**
	 * Enable UA web sdk for use with embedded content
	 */
	const { sdk } = await enableWebSdk();

	/**
	 * Get registered view areas
	 */
	const { views } = airship_web_sdk_settings?.embeddedContent || {};

	views.forEach(({ elementId, embeddedId }) => {
		const $el = document.querySelector(`#${elementId}`);

		if (!$el) {
			return;
		}

		sdk.components.embeddedViews.create($el, embeddedId);
	});
})();
